export default __webpack_public_path__ + "static/media/eh.0283e943.svg";